import React from 'react';
import BackLink from './BackLink';

const BackLinkDefault = (props) =>  //eslint-disable-line
  (<BackLink {...props} className="link-back-default" />);

export default BackLinkDefault;
